import { useEffect, useState } from "react";
import useRequest from "./use-req";

// The live event stream is wired to a real write key that belongs to one
// tenant (Meridian). Streaming it to anyone else would show them that
// tenant's customer events, so the real stream is only opened when the
// logged-in org (org_name off GET /auth/get_userdata) matches one of these
// case-insensitive substrings. Override for local/dev testing with
// REACT_APP_TRACK_LIVE_ORGS="meridian,dalmlabs" — every other org keeps the
// simulated demo stream.
const ALLOWED_ORGS = (process.env.REACT_APP_TRACK_LIVE_ORGS || "meridian")
  .split(",")
  .map((o) => o.trim().toLowerCase())
  .filter(Boolean);

// `npm start` builds (NODE_ENV=development) always get the real stream, so
// the feature can be developed and tested from any account; the tenant check
// only matters for deployed (production) builds.
const IS_DEV = process.env.NODE_ENV === "development";

// `checked` is false until the org lookup finishes, so callers can tell
// "not allowed" apart from "still finding out".
export function useTrackLiveAccess(): { allowed: boolean; checked: boolean; orgName: string } {
  const [state, setState] = useState({ allowed: IS_DEV, checked: IS_DEV, orgName: "" });
  const token = localStorage.getItem("authToken");
  const { makeRequest: getUserData } = useRequest("/auth/get_userdata", "GET", {
    Authorization: `Bearer ${token}`,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [response] = await getUserData();
      if (cancelled) return;
      const org = typeof response?.payload?.org_name === "string" ? response.payload.org_name : "";
      setState({ allowed: IS_DEV || ALLOWED_ORGS.some((o) => org.toLowerCase().includes(o)), checked: true, orgName: org });
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
}
